export const isCurrentPath = (path: string): boolean => {
	const currentPath = `${window.location?.pathname}${window.location?.search}`;
	return currentPath === path;
};
